import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import _ from "lodash";
import { useLocation, useNavigate } from "react-router-dom";
import Information from "./_information";
import { FormProvider, useForm } from "react-hook-form";
import { RentalForm } from "@/types/rental.type";
import { useAddRentalMutation } from "@/services/rental.service";
import moment from "moment-timezone";

export default function AddRental() {
    const { t } = useTranslation()
    const location = useLocation()
    const navigate = useNavigate()
    const [addRental, {isSuccess}] = useAddRentalMutation()
    const methods = useForm<RentalForm>()
    const {handleSubmit} = methods

    const onSubmit = handleSubmit((data) => {
        let now = moment()
        addRental({
            ...data,
            start_date: moment(`${data.start_date} ${now.hours()}:${now.minutes()}:${now.seconds()}.${now.milliseconds()}`, 'YYYY-MM-DD HH:mm:ss.SSS').toISOString(),
            end_date: moment(`${data.end_date} ${now.hours()}:${now.minutes()}:${now.seconds()}.${now.milliseconds()}`, 'YYYY-MM-DD HH:mm:ss.SSS').toISOString(),
            deposit_date: moment(`${data.deposit_date} ${now.hours()}:${now.minutes()}:${now.seconds()}.${now.milliseconds()}`, 'YYYY-MM-DD HH:mm:ss.SSS').toISOString(),
            rent_amount: Number(data.rent_amount),
            deposit_amount: Number(data.deposit_amount),
            late_fee: !_.isEmpty(data.late_fee) ? Number(data.late_fee) : 0,
            late_grace: data.late_grace,
            type: Number(data.type)
        })
    })

    useEffect(() => {
        if(isSuccess) {
            navigate(location, {state: {reload: true}})
        }
    }, [isSuccess])

    return (
        <div x-show="modalOpen" x-transition="" className="fixed top-0 left-0 z-99999 flex h-full min-h-screen w-full items-center justify-center bg-black/90 px-4 py-5">
            <div className="w-full max-w-screen-lg rounded-lg bg-white py-5 px-8 dark:bg-boxdark">
                <h3 className="text-xl dark:text-white text-center font-medium mb-5">
                    {t("rental.add_rental")}
                </h3>
                <form className="mx-5" onSubmit={onSubmit}>
                    <FormProvider {...methods}>
                        <Information />
                    </FormProvider>
                    <div className="flex justify-end">
                        <div className="px-3">
                            <button type="button" onClick={() => navigate(location)} className="block w-full rounded border border-stroke bg-gray-400 p-1.5 px-3 text-center font-medium text-black transition hover:bg-opacity-90">
                                {t("modal.cancel")}
                            </button>
                        </div>
                        <div className="px-3">
                            <button type="submit" className="flex w-full justify-center rounded bg-primary p-1.5 px-3 text-white hover:bg-opacity-90">
                                {t("modal.submit")}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}
